import * as React from "react"
import HubspotForm from "../HubspotForm/HubspotForm"
import { useEffect, useRef, useState } from "react"
import Helmet from "react-helmet"
import styled from "styled-components"
import { baseStyles, primaryStyles } from "../Button"
const StyledNewsletter = styled.div`
  width: 100%;

  .fs-webform-container .fserv-container {
    box-shadow: none;
    max-width: none;
  }

  .fs-webform-container .fserv-field + div:not(.fserv-field) {
    padding: 0;
  }

  &&& button.fserv-button-submit {
    width: 100%;
    ${baseStyles}
    ${primaryStyles}

    height: auto;
    font-size: 16px;
    line-height: 1;
  }

  .fs-webform-container .fserv-field {
    padding: 0;
  }

  &&& .powered-by {
    display: none !important;
  }
`

export default function NewsletterForm(props) {
  return (
    <>
      <Helmet>
        <script>{`
          (function(w,d,e,u,f,l,n){w[f]=w[f]||function(){(w[f].q=w[f].q||[]).push(arguments)},l=d.createElement(e),l.async=1,l.src=u,n=d.getElementsByTagName(e)[0],n.parentNode.insertBefore(l,n)})(window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
          ml('account','2143333');
        `}</script>
      </Helmet>
      <div
        className="ml-embedded"
        style={{ width: "100%" }}
        data-form="aXfBjA"
      ></div>
    </>
  )
}
